export default {
  pt_br: {
    i18next: 'pt-BR',
    dayjs: 'pt-br',
  },
  zh_cn: {
    i18next: 'zh',
    dayjs: 'zh-cn',
  },
  zh_tw: {
    i18next: 'zh',
    dayjs: 'zh-tw',
  },
};